// Footer.jsx
import React from "react";
import "./Footer.css";
import { Link, useNavigate } from 'react-router-dom'
import { SiGmail } from "react-icons/si";
import { FaInstagram, FaDiscord, FaYoutube, FaGithub } from "react-icons/fa";
import Logo from "../Images/Pi.png"; // replace with your actual logo path

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-footer">
      <div className="mt-footer__inner">
        <div className="mt-footer__top">
          <div className="mt-brand">
            <img src={Logo} alt="MathTounsi" className="mt-brand__logo" />
            <div className="mt-brand__text">
              <h3 className="mt-brand__title">MathTounsi</h3>
              <p className="mt-brand__tag">
                Your Math Olympiad Study Guide - a gateway to success.
                <br />
                Designed and developped by : Ahmed Mallek
              </p>
            </div>
          </div>

          <div className="mt-social" aria-label="MathTounsi social links">
            <a
              href="https://www.instagram.com/mathtounsi?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="mt-social__link"
            >
              <FaInstagram />
            </a>
            <a
              href="https://discord.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Discord"
              className="mt-social__link"
            >
              <FaDiscord />
            </a>
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=ahmedmallek2007@gmail.com"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
              className="mt-social__link"
            >
              <SiGmail />
            </a>
            <a
              href="https://github.com/MathTounsi/Community_Archive"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
              className="mt-social__link"
            >
              <FaGithub />
            </a>
          </div>
        </div>

        <div className="mt-footer__bottom">
          <p className="mt-copy">© {year} MathTounsi. All rights reserved.</p>
          <div className="mt-legal">
          <Link to="/Report">Report</Link>
             <span className="sep">·</span>
            <Link to="/terms">Terms</Link>
           
            
          </div>
        </div>
      </div>
    </footer>
  );
}
